import { StockStatus } from '../models/common/stock.model';

export function isUnavailableProduct(stockStatusCode?: StockStatus) {
  return stockStatusCode
    ? [
        StockStatus.CurrentlyUnavailable,
        StockStatus.CurrentlyUnavailableBeingDiscontinued,
        StockStatus.CurrentlyUnavailableBeingRemoved,
        StockStatus.CurrentlyUnavailableSupplyShortage,
        StockStatus.Discontinued,
        StockStatus.Removed,
      ].includes(stockStatusCode)
    : false;
}
